import { useLocale } from 'next-intl';
import styles from './fun88-virtual-fifa-world-cup-slider.module.scss';
import { CdnImg } from '@/features/cdn-img';
import { useRouter } from '@/navigation';
import { convertCultureToRef } from '@/utils/common-util';

/** 促銷圖僅提供此三種語系資產，其餘對應 en */
const SUPPORTED_ASSET_LOCALES: readonly string[] = ['en', 'vn', 'th'];

interface Fun88VirtualFifaWorldCupSliderProps {
	onClose: () => void;
}

export const Fun88VirtualFifaWorldCupSlider = ({ onClose }: Fun88VirtualFifaWorldCupSliderProps) => {
	const locale = useLocale();
	const shortLang = convertCultureToRef(locale ?? 'en-US', true);
	const assetLocale = SUPPORTED_ASSET_LOCALES.includes(shortLang) ? shortLang : 'en';
	const router = useRouter();

	const handleClickButton = () => {
		router.push('/world/fun88-virtual-fifa-world-cup/1/l');
		onClose();
	};

	return (
		<div className={styles.container} onClick={handleClickButton}>
			<CdnImg
				src={`/images/promotion-activity-modal/fun88-virtual-fifa-world-cup/${assetLocale}.png`}
				width={288}
				height={360}
				alt="Fun88 Virtual FIFA World Cup"
				isGalaxyFolder={true}
			/>
		</div>
	)
}